import { useState } from "react"
import { usePageAssets } from "hooks/usePageAssets"
import Button from "components/ui/Button"
import ContactSalesModal from "components/ContactSalesModal"
import Container from "components/ui/Container"
import CTA from "components/ui/CTA"

function CTASection() {
  const [modalOpen, setModalOpen] = useState(false)
  const { getAsset } = usePageAssets()
  const background = getAsset("single-cta-preset-background")
  return (
    <Container section>
      <CTA
        background={background}
        label="Ready to Get Started?"
        title="Unlock secure healthcare analytics with Preset"
        description="Schedule a demo to see how Preset can help your organization transform healthcare data into actionable insights while maintaining HIPAA compliance."
        size="wide"
        dark
      >
        <Button
          color="catskill-white"
          size="medium"
          trackClick="Book a Demo (cta)_HIPAA Compliance"
          onClick={() => setModalOpen(true)}
        >
          Book a Demo
        </Button>
      </CTA>
      <ContactSalesModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        sourcePage="HIPAA Compliance - CTA"
      />
    </Container>
  )
}

export default CTASection
